import http from '~/http/index';

export default ({
  state: {
    data: [],
    adminNotificationsSettings: [],
    filters: {},
    sort: {
      sort: 'defaultSort',
      sortDesc: false,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      return {
        ...filters,
        ...sort,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },

    SET_ADMIN_NOTIFICATIONS_SETTINGS(state, data) {
      state.adminNotificationsSettings = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.get('User/GetAdmins', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { items, total } = response.data;
      commit('SET_DATA', items);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
    },

    async changeAdminStatus(__store, params) {
      return http.put('User/ChangeAdminStatus', null, { params });
    },

    async blockAdmin(__store, AdminId) {
      return http.put('User/BlockAdmin', null, {
        params: { AdminId },
      });
    },

    async unblockAdmin(__store, AdminId) {
      return http.put('User/UnblockAdmin', null, {
        params: { AdminId },
      });
    },

    async createAdmin(__store, params) {
      return http.post('User/CreateAdmin', null, {
        params,
      });
    },

    async loadAdminNotificationsSettings({ commit }) {
      const response = await http.post('v2/Communication/GetAdminNotificationsSettings');
      const { items } = response.data;
      commit('SET_ADMIN_NOTIFICATIONS_SETTINGS', items);
    },

    async removeAdminNotificationsSettings(__store, data) {
      return http.put('v2/Communication/RemoveAdminNotificationsSettings', data);
    },

    async addAdminNotificationsSettings(__store, data) {
      return http.post('v2/Communication/AddAdminNotificationsSettings', data);
    },

    async editAdminNotificationsSettings(__store, data) {
      return http.put('v2/Communication/EditAdminNotificationsSettings', data);
    },
  },

  namespaced: true,
});
